import React, { FunctionComponent } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../helpers/intlHooks";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../app/contexts/Analytics/types";
import { useAppContext } from "../helpers/context-hooks/useAppContext";

interface FootnoteMarkerProps {
  id: string;
  marker: string;
}

const FootnoteMarker: FunctionComponent<FootnoteMarkerProps> = ({
  id,
  marker,
}) => {
  const t = useTranslate();
  const { dispatch } = useAppContext();
  const footnoteId = `${id}-footnote`;
  const markerId = `${id}-marker`;

  return (
    <Button
      size="small"
      variation="ghost"
      className="Footnote__marker"
      id={markerId}
      aria-label={t("footnote_marker.go_to_content")}
      onClick={(): void => {
        const footnote: HTMLDivElement | null = document.querySelector(
          `#${footnoteId}`
        );
        dispatch({
          type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
          settings: {
            button: {
              buttonStyle: AnalyticsButtonStyle.DEFAULT,
              buttonType: AnalyticsButtonType.LINK,
              text: marker,
            },
          },
        });
        footnote && footnote.scrollIntoView(false); // scroll bottom to bottom of viewport
        footnote?.focus();
      }}
    >
      <sup>{marker}</sup>
    </Button>
  );
};

export default FootnoteMarker;
